'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('continiousScroll', continiousScroll);

	function continiousScroll() {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				var visibleHeight = element.height();
				var threshold = 100;

				element.scroll(function() {
					var scrollableHeight = element.prop('scrollHeight');
					var hiddenContentHeight = scrollableHeight - visibleHeight;

					if (hiddenContentHeight - element.scrollTop() <= threshold) {
						// Scroll is almost at the bottom. Loading more rows
						scope.$apply(attrs.continiousScroll);
						// threshold += 200;
					}
				});
			}
		};
	}
})();
